import { SwiperContainer } from "./../_module/_carousel/swiper";
import { Opening } from "./../_module/_animation/opening";
import { LetterMotion } from "./../_module/_text/letterMotion";

export const News = {
  /**
   * funcs
   */
  init: () => {
    // HeadSnowAni.setCanvas()
    SwiperContainer.init();
    Opening.lowPageReady()
    LetterMotion.init(true)
  },
  isWhite:()=>{
    document.querySelector('#l-header').classList.add("is-white");
  }
};
